<template>
  <div>
    <v-container class="py-0 px-0">
      <v-card tile>
        <v-card-title>Input Tagihan External</v-card-title>
        <v-card-text class="py-0">
          <v-container class="px-0">
            <v-row>
              <v-col cols="12" sm="6" md="2" class="fit-content">
                <v-text-field
                  label="Kode Vessel"
                  dense
                  hide-details
                  v-model="formData.kv"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2" class="fit-content">
                <v-text-field
                  label="Tgl Tagihan"
                  dense
                  hide-details
                  type="date"
                  v-model="formData.tgl_tagihan"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2" class="fit-content">
                <v-combobox
                  label="Kategori Tagihan"
                  dense
                  hide-details
                  v-model="formData.kategori_tagihan"
                  :items="kategoriOptions"
                ></v-combobox>
              </v-col>
              <v-col cols="12" sm="6" md="2" class="fit-content">
                <v-text-field
                  label="No Tagihan"
                  dense
                  hide-details
                  v-model="formData.no_tagihan"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="Keterangan Tagihan"
                  dense
                  hide-details
                  v-model="formData.keterangan_tagihan"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2" class="fit-content">
                <v-text-field
                  label="Nilai Tagihan"
                  dense
                  hide-details
                  type="number"
                  v-model="formData.nilai_tagihan"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2" class="fit-content">
                <v-text-field
                  label="Tgl Jatuh Tempo"
                  dense
                  hide-details
                  type="date"
                  v-model="formData.tgl_jatuh_tempo"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="1" class="fit-content">
                <v-btn
                  color="primary"
                  :loading="loading.saveData"
                  :disabled="loading.saveData"
                  @click="saveData"
                  small
                >
                  Simpan
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <v-data-table
        :headers="dataHeaders"
        :items="data"
        :loading="loading.fetchData"
        :items-per-page="10"
        class="elevation-1 mt-2"
        dense
      >
        <template v-slot:item.nilai_tagihan="{ item }">
          {{ formatCurrency(item.nilai_tagihan) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item.id)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-container>

    <v-dialog v-model="editDialog" max-width="600px">
      <v-card>
        <v-card-title>Edit Tagihan</v-card-title>
        <v-card-text>
          <v-text-field label="No Tagihan" v-model="editFormData.no_tagihan" dense></v-text-field>
          <v-text-field label="Keterangan" v-model="editFormData.keterangan_tagihan" dense></v-text-field>
          <v-text-field label="Nilai Tagihan" type="number" v-model="editFormData.nilai_tagihan" dense></v-text-field>
          <v-text-field label="Tgl Jatuh Tempo" type="date" v-model="editFormData.tgl_jatuh_tempo" dense></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="editDialog = false">Batal</v-btn>
          <v-btn color="primary" @click="updateData" :loading="loading.saveData">Simpan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "InputTagihanExternal",
  data() {
    return {
      loading: {
        saveData: false,
        fetchData: false
      },
      formData: {
        kv: "",
        tgl_tagihan: "",
        kategori_tagihan: "",
        no_tagihan: "",
        keterangan_tagihan: "",
        nilai_tagihan: "",
        tgl_jatuh_tempo: ""
      },
      editFormData: {},
      editDialog: false,
      kategoriOptions: [],
      dataHeaders: [
        { text: "Kode Vessel", value: "kv" },
        { text: "Tgl Tagihan", value: "tgl_tagihan" },
        { text: "Kategori", value: "kategori_tagihan" },
        { text: "No Tagihan", value: "no_tagihan" },
        { text: "Keterangan", value: "keterangan_tagihan" },
        { text: "Nilai", value: "nilai_tagihan" },
        { text: "Jatuh Tempo", value: "tgl_jatuh_tempo" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      data: []
    };
  },
  watch: {
    "formData.kv"(val) {
      if (val) this.formData.kv = val.toUpperCase();
    }
  },
  methods: {
    formatCurrency(val) {
      if (!val) return "0";
      return Number(val).toLocaleString("id-ID");
    },
    async fetchData() {
      this.loading.fetchData = true;

      await axios
        .get(`tagihan-external`)
        .then(res => {
          this.data = res.data;
          this.loading.fetchData = false;
        })
        .catch(err => {
          this.loading.fetchData = false;
          alert(err.response.data.message);
        });
    },
    async fetchKategori() {
      await axios
        .get(`master-data?kategori=kategori_tagihan`)
        .then(res => {
          this.kategoriOptions = res.data.map(item => item.nama);
        })
        .catch(() => {});
    },
    async saveData() {
      this.loading.saveData = true;

      await axios
        .post(`tagihan-external`, this.formData)
        .then(res => {
          this.loading.saveData = false;
          this.fetchData();
          this.resetFormData();
        })
        .catch(err => {
          this.loading.saveData = false;
          alert(err.response.data.message);
        });
    },
    editItem(item) {
      this.editFormData = { ...item };
      this.editDialog = true;
    },
    async updateData() {
      this.loading.saveData = true;

      await axios
        .put(`tagihan-external/${this.editFormData.id}`, this.editFormData)
        .then(res => {
          this.loading.saveData = false;
          this.editDialog = false;
          this.fetchData();
        })
        .catch(err => {
          this.loading.saveData = false;
          alert(err.response.data.message);
        });
    },
    async deleteItem(id) {
      if (confirm("Yakin Untuk Menghapus?")) {
        await axios
          .delete(`tagihan-external/${id}`)
          .then(res => {
            this.fetchData();
          })
          .catch(err => {
            alert(err.response.data.message);
          });
      }
    },
    resetFormData() {
      this.formData.kv = "";
      this.formData.tgl_tagihan = "";
      this.formData.kategori_tagihan = "";
      this.formData.no_tagihan = "";
      this.formData.keterangan_tagihan = "";
      this.formData.nilai_tagihan = "";
      this.formData.tgl_jatuh_tempo = "";
    }
  },
  created() {
    this.fetchData();
    this.fetchKategori();
  }
};
</script>

<style scoped>
.fit-content {
  height: fit-content;
}
</style>
